var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    className: "st1",
    d: "M22.13,24l-8.4-8.4c-0.69,0.55-1.47,0.98-2.3,1.27c-0.89,0.31-1.82,0.47-2.77,0.47 c-2.31,0.05-4.54-0.86-6.15-2.52C0.86,13.2-0.05,10.98,0,8.67c-0.05-2.31,0.86-4.54,2.52-6.15C4.13,0.86,6.36-0.05,8.67,0 c2.31-0.05,4.54,0.86,6.15,2.52c1.65,1.62,2.56,3.84,2.52,6.15c0.01,0.94-0.15,1.88-0.47,2.77c-0.29,0.83-0.72,1.61-1.27,2.3 l8.4,8.4L22.13,24z M8.67,14.67c1.6,0.03,3.14-0.6,4.25-1.75c1.14-1.12,1.78-2.65,1.75-4.25c0.03-1.6-0.6-3.13-1.75-4.25 c-1.11-1.15-2.65-1.78-4.25-1.75c-1.6-0.03-3.14,0.6-4.25,1.75C3.27,5.53,2.64,7.07,2.67,8.67c-0.03,1.6,0.6,3.14,1.75,4.25 C5.53,14.06,7.07,14.7,8.67,14.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico_search.b03a7c341e7a6ec951ffa65996ffe1b6.svg";
export { ForwardRef as ReactComponent };